import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate, updateTemplateDetail } from "../../../../utils/faqApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CommonFaqTemplateWidget from "../../../../components/Apps/Faq/Template/CommonFaqTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/Faq/ContentTab";
import LayoutTab from "../../../../components/Apps/Faq/LayoutTab";
import AppearanceTab from "../../../../components/Apps/Faq/AppearanceTab";
import SettingsTab from "../../../../components/Apps/Faq/SettingTab";

export default function CreateTeamShowcase() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Search_Faq_Temp");
    const [selectedLayout, setSelectedLayout] = useState("search_faq_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("search-faq.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Faq");
    const [newWidgetName, setNewWidgetName] = useState("");
    const [isTemplateId, setTemplateId] = useState(null);
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);
    
    const [faqTabData, setFaqTabData] = useState({
        is_website_frontend: "", 
        is_show_display_category_title: 1,
        widget_title: "Frequently Asked Questions", 
        sidebar_layout_type: "",
        accordion_icon_type: "Plus",
        is_open_first_question_by_default: 1,    
        is_multiple_active_question: 1,       
        is_open_search_bar: 1,  
        template_type: "Background",  
        item_background_color: "",  
        question_text_color: "",  
        answer_text_color: "",  
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let sidebar_layout_type = "";
            let item_background_color = "";
            let question_text_color = "";
            let answer_text_color = "";
        
            switch (activeTemplateSection) {
                case "Search_Faq_Temp":
                    sidebar_layout_type = "Accordion";
                    item_background_color = "#fe9600";
                    question_text_color = "#000";
                    answer_text_color = "#000";
                    break;
                case "Accordion_Faq_Temp":
                    sidebar_layout_type = "Accordion";
                    item_background_color = "rgb(237, 237, 237)";
                    question_text_color = "#000";
                    answer_text_color = "#000";
                    break;
                case "Categories_Temp":
                    sidebar_layout_type = "Accordion";
                    item_background_color = "rgb(237, 237, 237)";
                    question_text_color = "#000";
                    answer_text_color = "#000";
                    break;
                case "Simple_Temp":
                    sidebar_layout_type = "List";
                    item_background_color = "rgb(237, 237, 237)";
                    question_text_color = "#000";
                    answer_text_color = "#000";
                    break;
                case "Faq_Dropdown_Temp":
                    sidebar_layout_type = "Accordion";
                    item_background_color = "rgb(237, 237, 237)";
                    question_text_color = "#000";
                    answer_text_color = "#000";
                    break;
                case "Multicolumn_Faq_Temp":
                    sidebar_layout_type = "Multicolumn";
                    item_background_color = "rgb(237, 237, 237)";
                    question_text_color = "#000";
                    answer_text_color = "#000";
                    break;
                default:
                    sidebar_layout_type = "";
                    item_background_color = "";
                    question_text_color = "";
                    answer_text_color = "";
            }
        
            // Update setFaqTabData state with the data
            setFaqTabData((prevData) => ({
                ...prevData,
                sidebar_layout_type: sidebar_layout_type,
                item_background_color: item_background_color,
                question_text_color: question_text_color,
                answer_text_color: answer_text_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateFaqTabData = (key, value) => {
        setFaqTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = async () => {
        setShowTemplateSelection(false);
        setIsSubmitting(false);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        }

      //Call Api To Create Templates with dummy data first
        try {
            // Collect data from refs
            const settingsArray = Object.entries(faqTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                    name: widgetName,
                    template_name: activeTemplateSection,
                    template_image: selectedTemplateImage,
                    layout_name: selectedLayout,
                    layout_type: selectedLayout,
                    app_type: "Faq",
                    settings: settingsArray,
            };
            
            //Api Call
            let api_response = await submitTemplate(payload);

            //Check Responce
            if (api_response.status === true) { 
                // Save templateId after first creation
                if (api_response.data.template_id) {
                    setTemplateId(api_response.data.template_id); 
                }
                setIsSubmitting(false); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    }; 

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Appearance", icon: "appearance.png", label: "Appearance" },
        { key: "Settings", icon: "settings.png", label: "Settings" },
    ];

    // Handle Source Tab input change
    const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(faqTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/faq');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Faq" app_type="Faq" app_slug="faq"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Search_Faq_Temp" data-layout_type="search_faq_layout" data-template_image="search-faq.png" checked={activeTemplateSection === "Search_Faq_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/faq/templates/search-faq.png`} alt="search-faq" />
                                    </div> 
                                    <div className="content_sub">Search in FAQ</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Accordion_Faq_Temp" data-layout_type="accordion_faq_layout" data-template_image="accordion-faq.png" checked={activeTemplateSection === "Accordion_Faq_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/faq/templates/accordion-faq.png`} alt="accordion-faq" />
                                    </div> 
                                    <div className="content_sub">Accordion FAQ</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Categories_Temp" data-layout_type="categories_layout" data-template_image="categories.png" checked={activeTemplateSection === "Categories_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/faq/templates/categories.png`} alt="categories" />
                                    </div> 
                                    <div className="content_sub">Categories</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Simple_Temp" data-layout_type="simple_layout" data-template_image="simple.png" checked={activeTemplateSection === "Simple_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/faq/templates/simple.png`} alt="simple" />
                                    </div> 
                                    <div className="content_sub">Simple FAQ</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Faq_Dropdown_Temp" data-layout_type="faq_dropdown_layout" data-template_image="faq-dropdown.png" checked={activeTemplateSection === "Faq_Dropdown_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/faq/templates/faq-dropdown.png`} alt="faq-dropdown" />
                                    </div> 
                                    <div className="content_sub">FAQ Dropdown </div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Multicolumn_Faq_Temp" data-layout_type="multicolumn_faq_layout" data-template_image="multicolumn-faq.png" checked={activeTemplateSection === "Multicolumn_Faq_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/faq/templates/multicolumn-faq.png`} alt="multicolumn-faq" />
                                    </div> 
                                    <div className="content_sub">Multicolumn FAQ</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/faq/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab isTemplateId={isTemplateId} setTemplateId={setTemplateId} updateFaqTabData={updateFaqTabData} faqTabData={faqTabData} setRefreshWidgetList={setRefreshWidgetList} />
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updateFaqTabData={updateFaqTabData} faqTabData={faqTabData} />
                            )}
                            {activeSection === "Appearance" && (
                              <AppearanceTab updateFaqTabData={updateFaqTabData} faqTabData={faqTabData} />
                            )}
                            {activeSection === "Settings" && (
                              <SettingsTab updateFaqTabData={updateFaqTabData} faqTabData={faqTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/faq"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/faq/faq.svg`} alt="faq"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                            <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                            <Link to="/customer/apps/faq/pricing/single" className="view-plan">View Plans</Link>
                            <Link to="/customer/apps/faq" className="close-button">Close</Link></div> 
                    </div>
                    <div className="source-title-row">Faq<i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common template*/}
                    <CommonFaqTemplateWidget isTemplateId={isTemplateId} faqTabData={faqTabData} refreshWidgetList={refreshWidgetList} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 